export const getPermissionListLoading = (state) => state.campaignList.get('loading');
export const getCampaignPermissionOrganisationId = (state, campaignId) => state.campaignList.getIn(['campaigns', campaignId, 'organisation', 'id']);
export const getCampaignPermissionRole = (state, campaignId) => state.campaignList.getIn(['campaigns', campaignId, 'role']);
export const getCampaignPermissionId = (state, campaignId) => state.campaignList.getIn(['campaigns', campaignId, 'id']);
export const getCampaignPermissionName = (state, campaignId) => state.campaignList.getIn(['campaigns', campaignId, 'name']);
export const getArchivedCampaignPermissionId = (state, campaignId) => state.campaignList.getIn(['archivedCampaigns', campaignId, 'id']);
export const getCampaignPermissionStatus = (state, campaignId) => state.campaignList.getIn(['campaigns', campaignId, 'status']);
export const getCampaignPermissionStatusFilter = (state) => state.campaignList.get('statusFilter');
export const getCampaignPermissionsByStatus = (state, status) => {
  const campaignPermissions = state.campaignList.get('campaigns');
  const filteredCampaignPermissions = campaignPermissions.filter(campaignPermission => {
    return campaignPermission.get('status') === status;
  });
  return filteredCampaignPermissions;
};
export const getIsMyCampaignPermission = (state, permissionId) => {
  const campaignPermissions = state.campaignList.get('campaigns');
  const isMyCampaignPermission = campaignPermissions.find(campaignPermission => {
    return campaignPermission.get('id') === permissionId;
  });
  return isMyCampaignPermission;
};



/** WEBPACK FOOTER **
 ** ./src/selectors/campaign-permission-selectors.js
 **/